import React, { useState, useEffect } from 'react';
import '../sources/styles/stylesCatalogo.css';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { useLocation, useParams } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CardProductoPrice } from '../components/CardProductoPrice';
import { Col, Container, Row, Form, Pagination, Accordion, Button, Offcanvas, InputGroup } from 'react-bootstrap';
import Slider from "react-slick";
import * as Icon from 'react-bootstrap-icons';
import ReactDOM from 'react-dom/client';

function Catalogo() {

    const Location = useLocation();
    const [dataSublinea, setDataSublinea] = useState([]);
    const [dataMarca, setDataMarca] = useState([]);
    const [singleLinea, setSingleLinea] = useState(undefined);
    const [lineaAux, setLineaAux] = useState(undefined);
    const [singleSublinea, setSingleSublinea] = useState(undefined);
    const [titleCategoria, setTitleCategoria] = useState('');
    const [titleBusqueda, setTitleBusqueda] = useState('');
    const [singleMarca, setSingleMarca] = useState(undefined);
    const [rangoInicial] = useState(0);
    const [rangoFinal, setRangoFinal] = useState(12);
    const [numPags, setNumPags] = useState([]);
    const [limitPage, setLimitPage] = useState(0);
    const [text, setText] = useState('');
    const [validacionPaginacion, setValidacionPaginacion] = useState(1);
    const [textValidacion, setTextValidacion] = useState(false);
    const [items, setItems] = useState([]);
    const [filtro, setFiltro] = useState(undefined);
    const [visualizacionFiltro, setVisualizacionFiltro] = useState('none');
    const [visualizacionProductos, setVisualizacionProductos] = useState('none');
    const [show, setShow] = useState(false);
    const cookie = new Cookies();
    const cookies = new Cookies();
    const accessToken = cookie.get('accesToken');
    const params = useParams();
    let urlMarca = params.marca;
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const imagenPublicidad = process.env.REACT_APP_SERVER_IMAGE + 'estaticas/';
    const [imagenLinea, setImagenLinea] = useState('fondo-general');
    const [tituloLinea, setTituloLinea] = useState('');
    const [filtroMarca, setFiltroMarca] = useState('');
    const [precioMinimo, setPrecioMinimo] = useState(0);
    const [precioMaximo, setPrecioMaximo] = useState(0);
    const [rangosPrecios, setRangosPrecios] = useState([]);
    const [rangoSeleccionado, setRangoSeleccionado] = useState([0, 0]);
    const [resultadoMensaje, setResultadoMensaje] = useState('');
    const [idMarcas, setIdMarcas] = useState('0');

    const formatoPesosColombianos = new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0
    });

    const manejarSeleccionRango = (e, rango) => {
        setRangoSeleccionado(rango);
        e.target.value = rango;
        handleFiltro(e);
        handleClose();
    };

    const handleSearchMarca = (event) => {
        setFiltroMarca(event.target.value);
    };

    const marcasFiltradas = dataMarca.filter((item) =>
        (item.descripcion_alternativa || item.descripcion_criterio).toLowerCase().includes(filtroMarca.toLowerCase())
    );

    const settingsMarcas = {
        dots: false,
        slidesToShow: 7,
        slidesToScroll: 2,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
    };

    const arrayMarcas = {
        0: ['HOLCIM', 'CELTA', 'SIKA', 'EUROCERAMICA', 'CERAMICA ITALIA', 'GERFOR', 'PINTURAS PINTUCO', 'BLACK + DECKER', 'ESAB', 'SWEISS', 'FURIUS', 'ELITE', 'DEWALT', 'STANLEY', 'IRWIN', 'TERINSA'],
        1: ['ALFAGRES', 'CERAMICA ITALIA', 'CHALLENGER', 'CORONA', 'CORTAG', 'DECORCERAMICA', 'EUROCERAMICA', 'FIRPLAK', 'GERFOR', 'GRIVAL', 'INTER MATEX', 'ROMA', 'SOCODA', 'TUCASA', 'UDUKE'],
        2: ['ACUAVIVA', 'ARGOS', 'CELTA', 'HERRAGRO', 'HOLCIM', 'PROTEJA', 'SIKA', 'SUPERBOARD', 'TEXSA', 'TOOLCRAFT'],
        4: ['BLACK + DECKER', 'CORTAG', 'DEWALT', 'ELITE', 'ESAB', 'FURIUS', 'HOYOSTOOLS', 'IRWIN', 'STANLEY', 'SWEISS', 'TOOLCRAFT', 'UDUKE'],
        5: ['HICASA', 'HOYOSTOOLS', 'PINTURAS ICO', 'PINTURAS PINTUCO', 'TEKBOND', 'TERINSA', 'TOOLCRAFT', 'UDUKE'],
        8: ['ACUAVIVA', 'BLACK + DECKER', 'COLPERFILES', 'DEWALT', 'ELITE', 'FURIUS', 'IRWIN', 'PROTEJA', 'STEELPRO', 'SWEISS', 'TOOLCRAFT'],
        11: ['GRIVAL', 'HOYOSTOOLS', 'IDEACE', 'ILUMAX', 'INDUMA', 'STEREN', 'TOOLCRAFT', 'UDUKE']
    };

    const queryTokenNuevo = async (item, tipo_cliente) => {
        const cookies = new Cookies();
        try {
            const ip = await consultarIp();
            const user = { id_cliente: ip, nombre: "", apellido_1: "", apellido_2: "", tipo_usuario: "temporal" };
            cookies.set('user', user, { path: '/' });
            const url = process.env.REACT_APP_SERVER + '/api/v1/token/productSingle';
            const body = { item_pedido: item, tipo_cliente: tipo_cliente, ipUsuario: ip };
            const { data } = await axios.post(url, body);
            cookies.set('accesToken', data.accessToken, { path: '/' });
            return data.accessToken;
        } catch (error) {
            console.log('Error en la consulta de token productSingle: ' + error.message);
            return null;
        }
    }

    const consultarIp = async () => {
        let ip = ''
        try {
            const url = 'https://www.cloudflare.com/cdn-cgi/trace';
            const { data } = await axios.get(url);
            ip = data.split('\n')
            ip = ip[2].split('=')
            ip = ip[1];
        } catch (err) {
            const url2 = 'https://geolocation-db.com/json/';
            const { data } = await axios.get(url2);
            ip = data.IPv4;
        }
        return ip
    }
    const queryLineas = async () => {
        const cookies = new Cookies();
        const accessToken = cookies.get('accesToken')
        try {
            const urlLinea = process.env.REACT_APP_SERVER + '/api/v1/items/linea';
            const responseLinea = await axios.get(urlLinea, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });
            cookies.set('accesToken', responseLinea.data[1], { path: '/' });
        } catch (err) {
            console.log('Error en la consulta de lineas: ' + err)
        }
    }
    const querySublinea = async (cod_linea, singleLinea2) => {
        const cookies = new Cookies();
        if (lineaAux !== cod_linea) {
            setLineaAux(cod_linea);

            const url = process.env.REACT_APP_SERVER + `/api/v1/items/sublinea/${cod_linea}`;
            const { data } = await axios.get(url, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });
            setSingleLinea(cod_linea)
            setDataSublinea(data[0]);
            if (data[0].length > 0) {
                cookies.set('accesToken', data[1], { path: '/' })
            }
        }
        setTextValidacion(false)
        console.log(textValidacion);
        setText('');
    }

    const queryMarca = async () => {
        const cookies = new Cookies();
        const accessToken = cookies.get('accesToken')
        const menu = cookies.get('menu')
        let datos = []
        if (menu !== undefined) {
            datos = [menu.split('_')[1], menu.split('_')[0]];
        }
        try {
            const urlLinea = process.env.REACT_APP_SERVER + '/api/v1/items/marca';
            const responseLinea = await axios.post(urlLinea, datos, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });
            setDataMarca(responseLinea.data[0]);
            cookies.set('accesToken', responseLinea.data[1], { path: '/' });
        } catch (err) {
            console.log('Error en la consulta de lineas: ' + err)
        }
    }

    const handleFiltro = async (e) => {
        const { name, value } = e.target;
        let filtroAux = '';
        let rangoAux = [];
        if (name === 'filtroSelect') {
            setFiltro(value);
            filtroAux = value;
            cookies.set('filtro', value);
        } else {
            filtroAux = 'rango';
            setFiltro('rango');
            cookies.set('filtro', 'rango');
            setValidacionPaginacion(1)
            if (value.length === 2) {
                rangoAux = value;
            } else {
                rangoAux = value.split(',');
            }
        }
        if (text === '') {
            if (singleLinea === undefined && singleSublinea === undefined) {
                if (singleMarca !== undefined) {
                    await queryNumsPags2(filtroAux, rangoAux, singleLinea, singleSublinea, singleMarca, rangoFinal);
                    const url = process.env.REACT_APP_SERVER + `/api/v1/items/marcaItems`;
                    const body = { cod_marca: singleMarca, rangoInicial, rangoFinal: rangoFinal, filtro: filtroAux, rango: rangoAux }
                    const { data } = await axios.post(url, body, {
                        headers: {
                            'Authorization': `Bearer ${accessToken}`
                        }
                    });
                    setItems(data)
                } else {
                    await queryNumsPags2(filtroAux, rangoAux, singleLinea, singleSublinea, singleMarca, rangoFinal);
                    const url = process.env.REACT_APP_SERVER + '/api/v1/items/catalogo';
                    const body = { cod_linea: singleLinea, cod_sublinea: singleSublinea, cod_marca: singleMarca, rangoInicial, rangoFinal: rangoFinal, filtro: filtroAux, rango: rangoAux }
                    const { data } = await axios.post(url, body, {
                        headers: {
                            'Authorization': `Bearer ${accessToken}`
                        }
                    });
                    setItems(data);
                }

            } else if (singleLinea !== undefined && singleSublinea === undefined) {
                await queryNumsPags2(filtroAux, rangoAux, singleLinea, singleSublinea, singleMarca, rangoFinal);
                const url = process.env.REACT_APP_SERVER + '/api/v1/items/catalogo';
                const body = { cod_linea: singleLinea, cod_sublinea: singleSublinea, cod_marca: singleMarca, rangoInicial, rangoFinal: rangoFinal, filtro: filtroAux, rango: rangoAux }
                const { data } = await axios.post(url, body, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                setItems(data);
            } else if (singleLinea === undefined && singleSublinea !== undefined) {
                await queryNumsPags2(filtroAux, rangoAux, singleLinea, singleSublinea, singleMarca, rangoFinal);
                const url = process.env.REACT_APP_SERVER + `/api/v1/items/sublineaItems`;
                const body = { cod_linea: singleLinea, cod_sublinea: singleSublinea, cod_marca: singleMarca, rangoInicial, rangoFinal: rangoFinal, filtro: filtroAux, rango: rangoAux }
                const { data } = await axios.post(url, body, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                setItems(data)
            } else if (singleLinea !== undefined && singleSublinea !== undefined) {
                await queryNumsPags2(filtroAux, rangoAux, singleLinea, singleSublinea, singleMarca, rangoFinal);
                const url = process.env.REACT_APP_SERVER + `/api/v1/items/sublineaItems`;
                const body = { cod_linea: singleLinea, cod_sublinea: singleSublinea, cod_marca: singleMarca, rangoInicial, rangoFinal: rangoFinal, filtro: filtroAux, rango: rangoAux }
                const { data } = await axios.post(url, body, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                setItems(data)
            }
        } else {
            await queryNumsPags2(filtroAux, rangoAux, singleLinea, singleSublinea, singleMarca, rangoFinal);
            const url = process.env.REACT_APP_SERVER + '/api/v1/items/busqueda';
            const body = { text: text, rangoInicial: rangoInicial, rangoFinal: rangoFinal, filtro: filtroAux, rango: rangoAux }
            const { data } = await axios.post(url, body, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });
            setItems(data);
        }
    }

    const handleRangoFinal = async (e) => {
        let rango = e.target.value;
        let inicialRango = 0;
        let index = 0;
        setRangoFinal(rango);
        cookies.set('rango', rango);
        if (cookies.get('paginas') !== undefined) {
            index = parseInt(cookies.get('paginas'));

            inicialRango = rangoFinal * (index - 1);
        }

        if (text === '') {
            if (singleLinea === undefined && singleSublinea === undefined) {
                if (singleMarca !== undefined) {
                    await queryNumsPags2(filtro, rangoSeleccionado, singleLinea, singleSublinea, singleMarca, rango);
                    const url = process.env.REACT_APP_SERVER + `/api/v1/items/marcaItems`;
                    const body = { cod_marca: singleMarca, rangoInicial: inicialRango, rangoFinal: rango, filtro: filtro, rango: rangoSeleccionado }
                    const { data } = await axios.post(url, body, {
                        headers: {
                            'Authorization': `Bearer ${accessToken}`
                        }
                    });
                    setItems(data)
                } else {
                    await queryNumsPags2(filtro, rangoSeleccionado, singleLinea, singleSublinea, singleMarca, rango);
                    const url = process.env.REACT_APP_SERVER + '/api/v1/items/catalogo';
                    const body = { cod_linea: singleLinea, cod_sublinea: singleSublinea, rangoInicial: inicialRango, rangoFinal: rango, filtro: filtro, rango: rangoSeleccionado }
                    const { data } = await axios.post(url, body, {
                        headers: {
                            'Authorization': `Bearer ${accessToken}`
                        }
                    });
                    setItems(data);
                }
            } else if (singleLinea !== undefined && singleSublinea === undefined) {
                await queryNumsPags2(filtro, rangoSeleccionado, singleLinea, singleSublinea, singleMarca, rango);
                const url = process.env.REACT_APP_SERVER + '/api/v1/items/catalogo';
                const body = { cod_linea: singleLinea, cod_sublinea: singleSublinea, rangoInicial: inicialRango, rangoFinal: rango, filtro: filtro, rango: rangoSeleccionado }
                const { data } = await axios.post(url, body, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                setItems(data);
            } else if (singleLinea === undefined && singleSublinea !== undefined) {
                await queryNumsPags2(filtro, rangoSeleccionado, singleLinea, singleSublinea, singleMarca, rango);
                const url = process.env.REACT_APP_SERVER + `/api/v1/items/sublineaItems`;
                const body = { cod_linea: singleLinea, cod_sublinea: singleSublinea, rangoInicial: inicialRango, rangoFinal: rango, filtro: filtro, rango: rangoSeleccionado }
                const { data } = await axios.post(url, body, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                setItems(data)
            } else if (singleLinea !== undefined && singleSublinea !== undefined) {
                await queryNumsPags2(filtro, rangoSeleccionado, singleLinea, singleSublinea, singleMarca, rango);
                const url = process.env.REACT_APP_SERVER + `/api/v1/items/sublineaItems`;
                const body = { cod_linea: singleLinea, cod_sublinea: singleSublinea, rangoInicial: inicialRango, rangoFinal: rango, filtro: filtro, rango: rangoSeleccionado }
                const { data } = await axios.post(url, body, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                setItems(data)
            }
        } else {
            const url = process.env.REACT_APP_SERVER + '/api/v1/items/busqueda';
            const body = { text: text, rangoInicial: rangoInicial, rangoFinal: rango, filtro: filtro, rango: rangoSeleccionado }
            console.log(body)
            const { data } = await axios.post(url, body, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });
            setItems(data);
        }
        setTimeout(() => {
            let paginaActiva = document.getElementsByClassName('page-item');

            for (let i = 0; i < paginaActiva.length - 1; i++) {

                if (paginaActiva[i] === paginaActiva[index - 1]) {
                    paginaActiva[i].className = 'page-item active';
                } else {
                    paginaActiva[i].className = 'page-item';
                }
            }
        }, 2000);

    }
    const handlePagination = async (index, linea, sublinea, marca) => {
        setValidacionPaginacion(index);
        let paginaActiva = document.getElementsByClassName('page-item');
        for (let i = 0; i < paginaActiva.length - 1; i++) {
            if (paginaActiva[i] === paginaActiva[index - 1]) {
                paginaActiva[i].className = 'page-item active';
            } else {
                paginaActiva[i].className = 'page-item';
            }
        }

        let filtroInicial = "";
        if (cookies.get('filtro') !== undefined) {
            filtroInicial = cookies.get('filtro');
        }
        setFiltro(filtroInicial)

        let rangoF = rangoFinal;
        if (cookies.get("rango") !== undefined) {
            rangoF = parseInt(cookies.get("rango"));
            setRangoFinal(rangoF);
        }

        window.scroll(0, 0)

        let inicialRango = 0;

        inicialRango = rangoFinal * (index - 1);
        if (text === '' && cookies.get('textoBuscar') === undefined) {

            if (linea !== undefined || sublinea !== undefined) {
                const url = process.env.REACT_APP_SERVER + '/api/v1/items/catalogo';
                const body = { cod_linea: linea, cod_sublinea: sublinea, rangoInicial: inicialRango, rangoFinal: rangoF, filtro: filtroInicial, rango: rangoSeleccionado }
                const { data } = await axios.post(url, body, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                setItems(data);

            } else {
                const url = process.env.REACT_APP_SERVER + '/api/v1/items/marcaItems';
                const body = { cod_marca: marca, cod_sublinea: marca, rangoInicial: inicialRango, rangoFinal: rangoF, filtro: filtroInicial, rango: rangoSeleccionado }
                const { data } = await axios.post(url, body, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                setItems(data);
            }
        } else {

            const url = process.env.REACT_APP_SERVER + '/api/v1/items/busqueda';
            const body = { text: cookies.get('textoBuscar'), rangoInicial: inicialRango, rangoFinal: rangoF, filtro: filtroInicial, rango: rangoSeleccionado };
            const { data } = await axios.post(url, body, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });

            setItems(data);
        }
    }
    const groupPageNext = async (index) => {
        let auxArray = [];
        let diferencia = limitPage - index;
        if (diferencia > 5) {
            for (let i = index + 1; i < index + 6; i++) {
                auxArray.push(i);
            }
        } else {
            for (let i = index + 1; i < limitPage; i++) {
                auxArray.push(i);
            }
        }
        setNumPags(auxArray);
    }
    const groupPagePrev = async (index) => {
        let auxArray = [];
        let diferencia = (index + 1) % 5;
        if (diferencia > 0) {
            for (let i = index - (4 + diferencia); i < (index + 1) - diferencia; i++) {
                auxArray.push(i);
            }
        } else {
            for (let i = index - 9; i < index - 4; i++) {
                auxArray.push(i);
            }
        }
        setNumPags(auxArray);
    }

    const queryItemsLinea = async (cod_linea, linea, validacionOffCanvasLinea = false) => {
        let filtroInicial = await ValidarFiltroInicial();
        setFiltro(filtroInicial)
        if (validacionOffCanvasLinea) {
            setShow(false);
        }
        setText('');
        setTextValidacion(false)
        setSingleLinea(cod_linea);
        await queryNumsPags2(filtroInicial, rangoSeleccionado, cod_linea, undefined, undefined, rangoFinal, false);
        setTitleBusqueda('');
        setSingleSublinea(undefined);
        setSingleMarca(undefined);
        const url = process.env.REACT_APP_SERVER + '/api/v1/items/catalogo';
        const body = { cod_linea, cod_sublinea: undefined, rangoInicial, rangoFinal, filtro: filtroInicial }
        const { data } = await axios.post(url, body, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        });
        setValidacionPaginacion(1)
        setItems(data);
        setTitleCategoria(linea);
    }

    const queryItemsSublinea = async (cod_sublinea, sublinea, validacionOffCanvasSublinea = false) => {
        let filtroInicial = await ValidarFiltroInicial();
        setFiltro(filtroInicial)
        if (validacionOffCanvasSublinea) {
            setShow(false);
        }
        setTextValidacion(false)
        setText('');
        setTitleBusqueda('')
        await queryNumsPags2(filtroInicial, rangoSeleccionado, undefined, cod_sublinea, undefined, rangoFinal, false);

        if (cookies.get('paginas') !== undefined && cookies.get('paginas') !== 1) {

            setValidacionPaginacion(cookies.get('paginas'))
            handlePagination(cookies.get('paginas'), undefined, cod_sublinea, undefined)
        } else {

            const url = process.env.REACT_APP_SERVER + `/api/v1/items/sublineaItems`;
            const body = { cod_linea: singleLinea, cod_sublinea: cod_sublinea, rangoInicial, rangoFinal, filtro: filtroInicial }
            const { data } = await axios.post(url, body, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });

            setValidacionPaginacion(1)
            setItems(data)
        }


        setSingleSublinea(cod_sublinea);
        setSingleMarca(undefined)
        setTitleCategoria(sublinea);
    }
    const queryItemsMarca = async (cod_marca, marca, validacionOffCanvasSublinea = false) => {
        let filtroInicial = await ValidarFiltroInicial();
        setImagenLinea('fondo-general');
        setIdMarcas('0');
        setValidacionPaginacion(1)
        if (validacionOffCanvasSublinea) {
            setShow(false);
        }
        setTextValidacion(false)
        setText('');
        setTitleBusqueda('')
        await queryNumsPags2(filtroInicial, rangoSeleccionado, undefined, undefined, marca, rangoFinal, false);
        const url = process.env.REACT_APP_SERVER + `/api/v1/items/marcaItems`;
        const body = { cod_marca: cod_marca, cod_sublinea: marca, rangoInicial, rangoFinal, filtro: filtroInicial }
        const { data } = await axios.post(url, body, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        });

        setItems(data)
        setSingleLinea(undefined);
        setSingleSublinea(undefined);
        setSingleMarca(marca);
        cookies.remove('textoBuscar');
        if (data.length === 0) {
            setTitleCategoria('Lamentablemente, No pudimos encontrar ningún resultado para tu búsqueda.');
        } else {
            setTitleCategoria(marca);
        }
    }
    const queryNumsPags2 = async (filtroAux, rangoAux, cod_linea, cod_sublinea, cod_marca, finalRango, validacionText) => {
        if (text === '') {
            const url = process.env.REACT_APP_SERVER + `/api/v1/items/numPags`;
            const cuerpo = { rangoFinal: finalRango === undefined ? rangoFinal : finalRango, singleLinea: cod_linea, singleSublinea: cod_sublinea, singleMarca: cod_marca, filtro: filtroAux, rango: rangoAux }
            const { data } = await axios.post(url, cuerpo, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });
            let arrayAux = [];
            if (filtroAux !== 'rango') {
                setPrecioMinimo(data[1]);
                setPrecioMaximo(data[2]);
            }
            if (data[0] >= 5) {
                setNumPags([0, 1, 2, 3, 4])
            } else {
                for (let index = 0; index < data[0]; index++) {
                    arrayAux.push(index)
                }

                setNumPags(arrayAux)
            }
            setLimitPage(data[0])
        } else {
            if (!validacionText) {
                const url = process.env.REACT_APP_SERVER + `/api/v1/items/numPags`;
                const cuerpo = { texto: text, rangoFinal: finalRango === undefined ? rangoFinal : finalRango, singleLinea: cod_linea, singleSublinea: cod_sublinea, singleMarca: cod_marca, filtro: filtroAux, rango: rangoAux }
                const { data } = await axios.post(url, cuerpo, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                let arrayAux = [];
                if (filtroAux !== 'rango') {
                    setPrecioMinimo(data[1]);
                    setPrecioMaximo(data[2]);
                }
                if (data[0] >= 5) {
                    setNumPags([0, 1, 2, 3, 4])
                } else {
                    for (let index = 0; index < data[0]; index++) {
                        arrayAux.push(index)
                    }

                    setNumPags(arrayAux)
                }
                setLimitPage(data[0])
            } else {
                const urlPags = process.env.REACT_APP_SERVER + '/api/v1/items/numPags/busqueda';
                const body = { text, rangoInicial: 0, rangoFinal: finalRango === undefined ? rangoFinal : finalRango }
                const responsePags = await axios.post(urlPags, body, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                if (filtroAux !== 'rango') {
                    setPrecioMinimo(responsePags[1]);
                    setPrecioMaximo(responsePags[2]);
                }
                let arrayAux = [];
                if (responsePags.data[0] > 5) {
                    arrayAux = [0, 1, 2, 3, 4]
                } else {
                    for (let index = 0; index < responsePags.data[0]; index++) {
                        arrayAux.push(index)
                    }
                }
                setNumPags(arrayAux)
                setLimitPage(responsePags.data[0])
            }
        }
    }
    const validationRoute = async () => {

        const cookies = new Cookies();
        let accessToken = cookies.get('accesToken');
        if (!accessToken) {
            if (urlMarca !== undefined) {
                if (!accessToken) {
                    accessToken = await queryTokenNuevo(urlMarca, 'B2C');
                    window.location.reload(true);
                }
            }
        }
        try {
            const url = process.env.REACT_APP_SERVER + "/requireAuth/routes";
            await axios.get(url, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });

        } catch (error) {
            console.log('La validación presentó error')
            console.log(error);
            cookies.remove('accessToken', { path: "/" });
            cookies.remove('username', { path: "/" });
            cookies.remove('id', { path: "/" });
            window.location.href = "/inicioSesion";
        }
    }
    const ValidarRango = async () => {
        let finalRango = 12;

        if (cookies.get("rango") !== undefined) {
            finalRango = cookies.get("rango");
        }
        return finalRango;
    }
    const ValidarFiltroInicial = async () => {
        let filtroInicial = "";

        if (cookies.get('filtro') !== undefined) {
            if (cookies.get('filtro') !== 'rango') {
                filtroInicial = cookies.get('filtro');
            }
        }
        cookies.set('filtro', filtroInicial, { path: '/' });
        return filtroInicial;
    }
    useEffect(() => {
        setImagenLinea('fondo-general');
        setIdMarcas('0');
        validationRoute();
        const cookies = new Cookies();
        const accessToken = cookies.get('accesToken');
        const user = cookies.get('user');
        const menu = cookies.get('menu');
        const pagina = cookies.get('paginas');

        if (pagina === undefined) {
            cookies.set('paginas', 1, { path: '/' });
        }

        document.getElementsByClassName('accordion-body').ariaExpanded = 'false';
        const queryItems = async () => {
            let inicioRagon = 0;
            if (cookies.get('rangoInicia') !== undefined) {
                inicioRagon = cookies.get('rangoInicia');

            } else {
                inicioRagon = 0;
            }
            let finalRango = await ValidarRango();
            setRangoFinal(finalRango);

            let filtroInicial = await ValidarFiltroInicial();
            setFiltro(filtroInicial)

            const url = process.env.REACT_APP_SERVER + '/api/v1/items/catalogo';
            const body = { rangoInicial: inicioRagon, rangoFinal: finalRango, filtro: filtroInicial }
            const { data } = await axios.post(url, body, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });
            setItems(data);
        }

        const queryNumPags = async (singleLinea, singleSublinea) => {
            let finalRango = await ValidarRango();
            setRangoFinal(finalRango);

            const url = process.env.REACT_APP_SERVER + `/api/v1/items/numPags`;
            const cuerpo = { rangoFinal: finalRango, singleLinea, singleSublinea, filtro: filtro, rango: rangoSeleccionado }
            const { data } = await axios.post(url, cuerpo, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });
            let arrayAux = [];
            setPrecioMinimo(data[1]);
            setPrecioMaximo(data[2]);
            if (data[0] >= 5) {
                setNumPags([0, 1, 2, 3, 4])
            } else {
                for (let index = 0; index < data[0]; index++) {
                    arrayAux.push(index)
                }
                setNumPags(arrayAux)
            }
            setLimitPage(data[0])
        }
        if (menu !== undefined) {

            if (urlMarca !== undefined) {
                queryItemsMarca(undefined, urlMarca);
            } else {
                //queryNumPags();
                let datosMenu = menu.split("_");

                if (datosMenu[0] === "sublinea") {
                    queryItemsSublinea(datosMenu[1], datosMenu[2]);
                } else {
                    if (datosMenu[0] === "linea") {
                        queryItemsLinea(datosMenu[1], datosMenu[2]);
                        setImagenLinea(`${datosMenu[0]}_${datosMenu[1]}`);
                        setIdMarcas(datosMenu[3]);
                        setTituloLinea(datosMenu[2]);
                    } else {

                        setVisualizacionProductos('block')
                        queryItemsLinea(datosMenu[1], datosMenu[2]);
                        querySublinea(datosMenu[1], '')
                    }
                }
            }

            if (pagina !== 1 && pagina !== undefined) {

                setValidacionPaginacion(pagina)

            }
        } else {

            if (Location.state !== null) {
                if (Location.state.page === '/' || Location.state.page === '/productSingle' || Location.state.page === '/carrito' || Location.state.page === '/estadoPedidos' || Location.state.page === '/estadoCartera' || Location.state.page === '/Ujueta' || Location.state.page === '/productSingleUjueta') {

                    if (urlMarca !== undefined) {
                        setTextValidacion(false)
                        setText('');
                        setTitleBusqueda('')
                    } else {
                        setTitleBusqueda(Location.state.text)
                        setText(Location.state.text);
                        setTextValidacion(true);
                    }
                    setItems(Location.state.data);
                    setNumPags(Location.state.numPags);
                    setLimitPage(Location.state.limitPags[0])
                    setPrecioMinimo(Location.state.limitPags[1]);
                    setPrecioMaximo(Location.state.limitPags[2]);
                } else {
                    if (urlMarca !== undefined) {
                        queryItemsMarca(undefined, urlMarca);
                    } else {
                        queryNumPags();
                    }
                }
            } else {
                if (urlMarca !== undefined) {
                    queryItemsMarca(undefined, urlMarca);
                } else {
                    queryNumPags();
                }
            }

            if (pagina !== 1 && pagina !== undefined) {
                handlePagination(pagina, undefined, undefined, undefined)
                setValidacionPaginacion(pagina)
            } else {

                if (cookies.get('textoBuscar') === undefined) {
                    if (urlMarca !== undefined) {
                        queryItemsMarca(undefined, urlMarca);
                    } else {
                        queryItems();
                    }
                } else {
                    setTitleBusqueda(cookies.get('textoBuscar'))
                    handlePagination(1, undefined, undefined, undefined);
                    setValidacionPaginacion(1)
                }
            }

        }

        if (user) {
            if (user.tipo_usuario === 'temporal' || user.lista_de_precios === '014' || user.lista_de_precios === '001' || user.lista_de_precios === '010') {
                setVisualizacionFiltro('block')
            }
        }

        const actualizarCarrito = async () => {
            const urlCarrito = process.env.REACT_APP_SERVER + '/api/v1/shoppingCart/list';
            const responseCarrito = await axios.get(urlCarrito, {
                headers: {
                    "Authorization": `Bearer ${accessToken}`
                }
            });
            const dataCarrito = responseCarrito.data[0];
            cookies.set('carrito', (dataCarrito.length));
            if (user.tipo_usuario === 'temporal') {
                const root = ReactDOM.createRoot(
                    document.getElementById('numberCarTemporal')
                );
                const element = <span className="badge badge-dark">{cookies.get('carrito')}</span>
                root.render(element);
            } else {
                const root = ReactDOM.createRoot(
                    document.getElementById('numberCar')
                );
                const element = <span className="badge badge-dark">{cookies.get('carrito')}</span>
                root.render(element);
            }
        }
        actualizarCarrito();

        queryMarca();
        //actualizarRango(cookies.get("textoBuscar"), rangoInicial, cookies.get("rango"), filtro);
        // eslint-disable-next-line 
    }, []);

    useEffect(() => {
        const redondearPrecio = (precio) => {
            const factor = Math.pow(10, Math.floor(Math.log10(precioMaximo)) - 1);
            return Math.round(precio / factor) * factor;
        };

        setRangosPrecios([
            [precioMinimo, redondearPrecio(precioMinimo + (precioMaximo - precioMinimo) * 1 / 6)],
            [redondearPrecio(precioMinimo + (precioMaximo - precioMinimo) * 1 / 6), redondearPrecio(precioMinimo + (precioMaximo - precioMinimo) * 2 / 6)],
            [redondearPrecio(precioMinimo + (precioMaximo - precioMinimo) * 2 / 6), redondearPrecio(precioMinimo + (precioMaximo - precioMinimo) * 3 / 6)],
            [redondearPrecio(precioMinimo + (precioMaximo - precioMinimo) * 3 / 6), redondearPrecio(precioMinimo + (precioMaximo - precioMinimo) * 4 / 6)],
            [redondearPrecio(precioMinimo + (precioMaximo - precioMinimo) * 4 / 6), redondearPrecio(precioMinimo + (precioMaximo - precioMinimo) * 5 / 6)],
            [redondearPrecio(precioMinimo + (precioMaximo - precioMinimo) * 5 / 6), precioMaximo]
        ]);
        setRangoSeleccionado([0, 0]);
    }, [precioMinimo, precioMaximo]);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (items.length === 0) {
                setResultadoMensaje('No se encontraron resultados para la búsqueda');
            } else {
                setResultadoMensaje('');
            }
        }, 2000);
        return () => clearTimeout(timer);
    }, [items]);

    const isMobile = window.innerWidth <= 768 ? '-movil' : '';

    return (
        <>
            <Header busquedaItems={{ setItems, setLimitPage, setNumPags, setTitleBusqueda, setText, rangoFinal, filtro, setFiltro, setValidacionPaginacion, setTextValidacion, setVisualizacionProductos, setImagenLinea, setIdMarcas, setPrecioMinimo, setPrecioMaximo }} />
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '110%',
                    backgroundImage: `url(${imagenPublicidad}${(visualizacionFiltro === 'none' && imagenLinea === 'fondo-general') ? 'fondo-general-busqueda' + isMobile + '.webp' : imagenLinea + isMobile + '.webp'})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    zIndex: -1,
                }}
            />
            <br></br>
            <Container fluid="xxl" className='containerCatalogo'>
                <Row className="align-items-center ms-3 me-3">
                    <Col xs={10} className="carruselMarca divFlechasProductosNuevos">
                        <Slider {...settingsMarcas}>
                            {arrayMarcas[idMarcas].map((marca, i) => (
                                <Row key={i}>
                                    <Col className='imgMarcas'>
                                        <a href={`/catalogo/${marca}`}>
                                            <img
                                                loading='lazy'
                                                fallback={<p>Cargando</p>}
                                                id={i}
                                                className="mx-auto img-fluid"
                                                src={process.env.REACT_APP_SERVER_IMAGE + 'marcas_catalogo/' + marca + '.png'}
                                                alt={marca}
                                                width={'80%'}
                                                height={'80%'}
                                            />
                                        </a>
                                    </Col>
                                </Row>
                            ))
                            }
                        </Slider>
                    </Col>
                </Row>
                {
                    imagenLinea === 'fondo-general' ?
                        <Row>
                            {items.length > 0 ?
                                <Col md={{ span: 6, offset: 3 }}><b className='b_textProducto'>{titleBusqueda === '' ? titleCategoria : 'Resultado de ' + titleBusqueda}</b></Col>
                                :
                                <Col md={{ span: 6, offset: 3 }}><h1><b className='b_textProducto'>{resultadoMensaje}</b></h1></Col>
                            }
                        </Row>
                        :
                        <Row>
                            {
                                imagenLinea !== 'fondo-general' &&
                                <Col xs={12} className="d-flex text-center mx-auto justify-content-center align-items-center">
                                    <h1 className="tituloCategoria lh-1">
                                        {tituloLinea.split(' ').map((word, index) => (
                                            <span key={index} className={index === 0 ? "primerTitulo" : index === 1 ? "segundoTitulo" : "tercerTitulo"} style={index > 1 ? {} : { display: 'block' }}>{word} </span>
                                        ))}
                                    </h1>
                                </Col>
                            }
                        </Row>
                }
                <Row>
                    <Col xs={12} sm={4} md={3} className='mt-1'>
                        <Row className="mb-2">
                            <Col xs={12} sm={12} md={12} lg={5}>
                                <Form.Select size="sm" onChange={handleRangoFinal} value={rangoFinal} className={'filtroSelect'}>
                                    <option value={12}>{12}</option>
                                    <option value={24}>{24}</option>
                                </Form.Select>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={7} style={{ display: visualizacionFiltro }}>
                                <Form.Select size="sm" name="filtroSelect" onChange={handleFiltro} value={filtro} className={'filtroSelect'}>
                                    <option value={''}>Más vendidos</option>
                                    <option value={'Mayor'}>Mayor Precio</option>
                                    <option value={'Menor'}>Menor Precio</option>
                                </Form.Select>
                            </Col>
                        </Row>
                        <Row>
                            <Col className={'divCanvas'}>
                                <div id="divOffcanvasCategorias">
                                    <Button variant="dark" onClick={handleShow} style={{ margin: '10px 0px', fontSize: '16px' }}>
                                        <Icon.Filter /> Filtrar
                                    </Button>
                                    <Offcanvas show={show} onHide={handleClose}>
                                        <Offcanvas.Header closeButton />
                                        <Offcanvas.Body>
                                            <Accordion>
                                                <Accordion.Item className="mb-2" eventKey="0" style={{ display: visualizacionProductos, boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }} >
                                                    <Accordion.Header className={(titleBusqueda === '' && singleSublinea) && 'headerAcordion'}><h5 onClick={() => queryLineas()} className='h5_titulosMenu' style={{ width: '100%' }}>SUBLINEAS DE PRODUCTOS</h5><Icon.CaretDownFill /></Accordion.Header>
                                                    <Accordion.Body>
                                                        <ul>
                                                            {
                                                                dataSublinea.map((element, e) =>
                                                                    <li key={e} className="li_filtros"><p className="p_filtros" onClick={() => queryItemsSublinea(element.cod_criterio, element.descripcion_alternativa === null ? element.descripcion_criterio : element.descripcion_alternativa, true)}>{element.descripcion_alternativa === null ? element.descripcion_criterio.toUpperCase() : element.descripcion_alternativa.toUpperCase()}</p></li>
                                                                )
                                                            }
                                                        </ul>
                                                    </Accordion.Body>
                                                </Accordion.Item >
                                                <Accordion.Item className="mb-2" style={{ boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }} eventKey="1">
                                                    <Accordion.Header className={(titleBusqueda === '' && singleMarca) && 'headerAcordion'}><h5 onClick={() => queryMarca()} className='h5_titulosMenu' style={{ width: '100%' }}>MARCAS DE PRODUCTOS</h5><Icon.CaretDownFill /></Accordion.Header>
                                                    <Accordion.Body>
                                                        <Accordion>
                                                            <InputGroup size="sm" className="mt-1 outline-warning">
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Filtrar Marcas"
                                                                    value={filtroMarca}
                                                                    onChange={handleSearchMarca}
                                                                    aria-describedby="buscarMarcas"
                                                                />
                                                                <InputGroup.Text id="buscarMarcas"><Icon.Search /></InputGroup.Text>
                                                            </InputGroup>
                                                            <hr></hr>
                                                            <ul>
                                                                {
                                                                    marcasFiltradas.map((element, e) =>
                                                                        <li key={e}><p className="p_filtros" onClick={() => queryItemsMarca(element.cod_criterio, element.descripcion_alternativa === null ? element.descripcion_criterio : element.descripcion_alternativa, true)}>{element.descripcion_alternativa === null ? element.descripcion_criterio : element.descripcion_alternativa}</p> </li>
                                                                    )
                                                                }
                                                            </ul>
                                                        </Accordion>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                                {precioMaximo > 0 &&
                                                    <Accordion.Item className="mb-2" style={{ boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }} eventKey="3" >
                                                        <Accordion.Header className={rangoSeleccionado[0] !== 0 && 'headerAcordion'}><h5 className='h5_titulosMenu' style={{ height: '35px', width: '100%' }}>RANGOS DE PRECIO</h5><Icon.CaretDownFill /></Accordion.Header>
                                                        <Accordion.Body>
                                                            <Row>
                                                                <Col sm={12} className="overflow-auto">
                                                                    <div className="divCategorias">
                                                                        <Row>
                                                                            <Col xs={2}>
                                                                                <Button variant="outline-warning" onClick={() => setRangoSeleccionado([precioMinimo, rangoSeleccionado[1] - 10000])}>-</Button>
                                                                            </Col>
                                                                            <Col xs={8}>
                                                                                <Form.Control
                                                                                    size="sm"
                                                                                    className='text-center'
                                                                                    min="0"
                                                                                    max={precioMaximo}
                                                                                    name="filtroRango"
                                                                                    type="number"
                                                                                    value={rangoSeleccionado[1]}
                                                                                    onChange={(e) => setRangoSeleccionado([rangoSeleccionado[0], Number(e.target.value)])}
                                                                                />
                                                                            </Col>
                                                                            <Col xs={2}>
                                                                                <Button variant="outline-warning" onClick={() => setRangoSeleccionado([precioMinimo, rangoSeleccionado[1] + 10000])}>+</Button>
                                                                            </Col>
                                                                        </Row>
                                                                        <Row className="justify-content-center">
                                                                            <Col xs={4}>
                                                                                <Button variant="outline-warning" onClick={(e) => manejarSeleccionRango(e, [precioMinimo, rangoSeleccionado[1]])}><Icon.Search /></Button>
                                                                            </Col>
                                                                        </Row>
                                                                        <hr></hr>
                                                                        {rangosPrecios.map((rango, index) => (
                                                                            <div key={index} style={{ margin: '0' }}>
                                                                                <input
                                                                                    type="radio"
                                                                                    id={`rango2-${index}`}
                                                                                    name="filtroRango2"
                                                                                    value={index}
                                                                                    checked={rango === rangoSeleccionado}
                                                                                    onChange={(e) => manejarSeleccionRango(e, rango)}
                                                                                    style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                                                                                    className="custom-radio-warning"
                                                                                />
                                                                                <label htmlFor={`rango2-${index}`} style={{ cursor: 'pointer', marginLeft: '5px' }}>
                                                                                    <Row className="text-center">
                                                                                        <Col xs={5}>{formatoPesosColombianos.format(parseInt(rango[0]))}</Col>
                                                                                        <Col xs={2}>-</Col>
                                                                                        <Col xs={5}>{formatoPesosColombianos.format(parseInt(rango[1]))}</Col>
                                                                                    </Row>
                                                                                </label>
                                                                                <hr></hr>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                }
                                            </Accordion>
                                        </Offcanvas.Body>
                                    </Offcanvas>
                                </div>
                                <div id="divAccordionCategorias">
                                    <Accordion defaultActiveKey="1">
                                        <Accordion.Item className="mb-2" eventKey="0" style={{ display: visualizacionProductos, boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }} >
                                            <Accordion.Header className={(titleBusqueda === '' && singleSublinea) && 'headerAcordion'}><h5 className='h5_titulosMenu' style={{ height: '35px', width: '100%' }}>Sublineas de productos</h5><Icon.CaretDownFill /></Accordion.Header>
                                            <Accordion.Body>
                                                <ul>
                                                    {
                                                        dataSublinea.map((element, e) =>
                                                            <li key={e} className="li_filtros"><p className="p_filtros" onClick={() => queryItemsSublinea(element.cod_criterio, element.descripcion_alternativa === null ? element.descripcion_criterio : element.descripcion_alternativa)}>{element.descripcion_alternativa === null ? element.descripcion_criterio.toUpperCase() : element.descripcion_alternativa.toUpperCase()}</p></li>
                                                        )
                                                    }
                                                </ul>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item style={{ boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }} className="mb-2" eventKey="1" id='acordionMarcas'>
                                            <Accordion.Header className={(titleBusqueda === '' && singleMarca) && 'headerAcordion'}><h5 onClick={() => queryMarca()} className='h5_titulosMenu' style={{ height: '35px', width: '100%' }}>Marcas de productos</h5><Icon.CaretDownFill /></Accordion.Header>
                                            <Accordion.Body>
                                                <Row>
                                                    <Col sm={12} className="overflow-auto">
                                                        <div className="divCategorias">
                                                            <InputGroup size="sm" className="mt-1">
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Filtrar Marcas"
                                                                    value={filtroMarca}
                                                                    onChange={handleSearchMarca}
                                                                />
                                                                <Button disabled variant="outline-warning"><Icon.Search /></Button>
                                                            </InputGroup>
                                                            <hr></hr>
                                                            <Accordion>
                                                                {
                                                                    marcasFiltradas.map((item, i) =>
                                                                        <Accordion.Item key={i} eventKey={i}>
                                                                            <p className="p_filtros" onClick={() => queryItemsMarca(item.cod_criterio, item.descripcion_alternativa === null ? item.descripcion_criterio : item.descripcion_alternativa)}>{item.descripcion_alternativa === null ? item.descripcion_criterio : item.descripcion_alternativa}</p>
                                                                        </Accordion.Item>
                                                                    )
                                                                }
                                                            </Accordion>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        {precioMaximo > 0 &&
                                            <Accordion.Item style={{ boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }} eventKey="3" >
                                                <Accordion.Header className={rangoSeleccionado[0] !== 0 && 'headerAcordion'} ><h5 className='h5_titulosMenu' style={{ height: '35px', width: '100%' }}>Precio</h5><Icon.CaretDownFill /></Accordion.Header>
                                                <Accordion.Body>
                                                    <Row>
                                                        <Col sm={12} className="overflow-auto">
                                                            <div className="divCategorias">
                                                                <InputGroup size="sm">
                                                                    <Button variant="outline-warning" onClick={() => setRangoSeleccionado([precioMinimo, rangoSeleccionado[1] - 10000])}>-</Button>
                                                                    <Form.Control
                                                                        min="0"
                                                                        max={precioMaximo}
                                                                        name="filtroRango"
                                                                        type="number"
                                                                        value={rangoSeleccionado[1]}
                                                                        onChange={(e) => setRangoSeleccionado([rangoSeleccionado[0], Number(e.target.value)])}
                                                                    />
                                                                    <Button variant="outline-warning" onClick={() => setRangoSeleccionado([precioMinimo, rangoSeleccionado[1] + 10000])}>+</Button>
                                                                    <Button variant="outline-warning" onClick={(e) => manejarSeleccionRango(e, [precioMinimo, rangoSeleccionado[1]])}><Icon.Search /></Button>
                                                                    <Button variant="outline-secondary" name="filtroSelect" value='' onClick={(e) => { handleFiltro(e); setRangoSeleccionado([0, 0]); }} >x</Button>
                                                                </InputGroup>
                                                                <hr></hr>
                                                                {rangosPrecios.map((rango, index) => (
                                                                    <div key={index} style={{ margin: '0' }}>
                                                                        <input
                                                                            type="radio"
                                                                            id={`rango-${index}`}
                                                                            name="filtroRango"
                                                                            value={index}
                                                                            checked={rango === rangoSeleccionado}
                                                                            onChange={(e) => manejarSeleccionRango(e, rango)}
                                                                            style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                                                                            className="custom-radio-warning"
                                                                        />
                                                                        <label htmlFor={`rango-${index}`} style={{ cursor: 'pointer', fontSize: '1rem' }}>
                                                                            <Row className="text-center textoFiltro ms-1">
                                                                                <Col className="p-2" sm={8} md={5}><small>{formatoPesosColombianos.format(parseInt(rango[0]))}</small></Col>
                                                                                <Col className="p-2" sm={1} md={1}>-</Col>
                                                                                <Col className="p-2" sm={11} md={5}><small>{formatoPesosColombianos.format(parseInt(rango[1]))}</small></Col>
                                                                            </Row>
                                                                        </label>
                                                                        <hr></hr>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        }
                                    </Accordion>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    {
                        items.map((item) =>
                            <Col key={item.item_pedido} className='imgCatalogo'>
                                <CardProductoPrice propiedades={item} />
                            </Col>
                        )
                    }
                </Row>
                <Row>
                    <Col className="mx-auto p-3" >
                        <Pagination className="mx-auto" style={{ width: '300px' }}>
                            {numPags[0] + 1 === 1 ? <div style={{ width: "40px" }}></div> : <Pagination.Prev onClick={() => groupPagePrev(numPags[numPags.length - 1])} />}
                            {
                                numPags.map((item, i) =>
                                    <Pagination.Item key={item + 1} onClick={() => { handlePagination(item + 1, singleLinea, singleSublinea, singleMarca); cookies.set('paginas', item + 1, { path: '/' }) }} active={validacionPaginacion === item + 1}>{item + 1}</Pagination.Item>
                                )
                            }
                            {numPags[numPags.length - 1] + 1 >= limitPage ? null : <Pagination.Next onClick={() => groupPageNext(numPags[numPags.length - 1])} />}
                        </Pagination>
                    </Col>
                </Row>
            </Container>

            <div>
                <img style={{ width: '100%', maxWidth: '100%' }} src={imagenPublicidad + 'medios-pago.webp'} alt="medios de pago" />
            </div>
            <Footer />
        </>
    )
}

export { Catalogo };